import request from '../../request'

export default {
    actions: {
        testRequest() {
            return request.get('test');
        },
        getCoiffeurAppointments(_, payload) {
            return request.get('coiffeurAppointments', {
                params: payload,
            })
        },
        createCoiffeurAppointment(_, data) {
            return request.post('coiffeurAppointments', data);
        },
        deleteCoiffeurAppointment(_, id) {
            return request.delete('coiffeurAppointments/' + id);
        },

        CoiffeurAppointmentReminder(_, payload) {
            return request.post('coiffeur-appointment-reminder', payload)
        },

        setPassiveCoiffeur(_, id) {
            return request.post('coiffeur-appointment-set-passive/' + id)
        }
    }
};
